import { useSelector } from 'react-redux';
import { useLocalization, useSelectedOrdersRows } from '@/Hooks';
import { localizationUtils } from '@/Utils/localizationUtils';
import { globalSelectors } from '@/Redux/Global/selectors';
import { stringUtils } from '@/Utils';
import { useMemo } from 'react';
import { NumberGenerationType } from 'src/Enums';

export function useGenerateDocumentNumbersTexts(numberGenerationType?: NumberGenerationType) {
  const {
    enums: { NumberGenerationType },
    modalWindows: { generateDocumentNumbers },
  } = useLocalization();

  const { orderIds } = useSelectedOrdersRows();
  const localization = useSelector(globalSelectors.localization);

  const confirmationText = useMemo(() => {
    const confirmationTextPart = numberGenerationType
      ? localizationUtils.insertTranslatedParamsToString(
          NumberGenerationType[numberGenerationType],
          [orderIds.length],
          NumberGenerationType.parts,
          localization,
        )
      : '';

    return numberGenerationType
      ? stringUtils.insertParamsToString(generateDocumentNumbers.ConfirmationText, [confirmationTextPart])
      : '';
  }, [NumberGenerationType, numberGenerationType, generateDocumentNumbers, orderIds.length, localization]);

  return {
    confirmationText,
  };
}
